
const GalleryData = [
    //  first view images
    {
        "image": "/images/gallery/view/adventure-resort-view-1.jpg",
        "category": "View",
    },
    {
        "image": "/images/gallery/view/adventure-resort-view-2.jpg",
        "category": "View",
    },
    //  first activities images
    {
        "image": "/images/gallery/activities/Activity-17.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-9.jpg",
        "category": "Activities",
    },

    //  first accomodation images
    {
        "image": "/images/gallery/rooms/room-img1.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img6.jpg",
        "category": "Accommodation",
    },

    //  first Dining images
    {
        "image": "/images/gallery/dinning/Dinning_21.jpg",
        "category": "Dining",
    },

    //  first Video images
    {
        "videoUrl": "4o9FDWomIiU",
        "category": "Videos",
    },

    //  first banquet images
    {
        "image": "/images/gallery/banquet/Banquet_12.jpg",
        "category": "Wedding & Events",
    },


    // View
    {
        "image": "/images/gallery/view/adventure-resort-view-3.jpg",
        "category": "View",
    },
    {
        "image": "/images/gallery/view/adventure-resort-view-4.jpg",
        "category": "View",
    },
    {
        "image": "/images/gallery/view/adventure-resort-view-5.jpg",
        "category": "View",
    },

    // Activities
    {
        "image": "/images/gallery/activities/Activity-1.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-2.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-3.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-4.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-5.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-6.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-7.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-8.jpg",
        "category": "Activities",
    },

    {
        "image": "/images/gallery/activities/Activity-10.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-11.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-12.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-13.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-14.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-15.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-16.jpg",
        "category": "Activities",
    },

    {
        "image": "/images/gallery/activities/Activity-18.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-19.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-20.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-21.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-22.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-23.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-24.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-25.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-26.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-27.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-28.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-29.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-30.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-31.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-32.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-33.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-34.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-35.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-36.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-37.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-38.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-39.jpg",
        "category": "Activities",
    },
    {
        "image": "/images/gallery/activities/Activity-40.jpg",
        "category": "Activities",
    },


    // Accomodation
    {
        "image": "/images/gallery/rooms/room-img3.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img4.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img5.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img2.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img7.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img8.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img9.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img10.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img11.jpg",
        "category": "Accommodation",
    },
    {
        "image": "/images/gallery/rooms/room-img12.jpg",
        "category": "Accommodation",
    },

    // Dining
  
    {
        "image": "/images/gallery/dinning/Dinning_2.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_3.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_4.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_6.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_7.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_8.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_9.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_10.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_11.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_12.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_13.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_14.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_15.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_16.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_17.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_18.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_19.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_20.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_1.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_22.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_23.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_24.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_25.jpg",
        "category": "Dining",
    },
    {
        "image": "/images/gallery/dinning/Dinning_26.jpg",
        "category": "Dining",
    },



    // Videos
    {
        "videoUrl": "wAn1MtgrA3E",
        "category": "Videos",
    },

    // Banquet

    {
        "image": "/images/gallery/banquet/Banquet_2.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_3.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_4.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_5.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_6.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_7.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_8.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_9.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_10.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_11.jpg",
        "category": "Wedding & Events",
    },
    {
        "image": "/images/gallery/banquet/Banquet_1.jpg",
        "category": "Wedding & Events",
    }
]

export default GalleryData;

{/* alt={`Adventure Resort ${filteredProperty?.category} `} */ }